export default __webpack_public_path__ + "static/media/banner-3.353e65d6.webp";